/*
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 17:13:44
 * @LastEditTime: 2020-07-16 17:14:28
 */
import * as stores from './views/children/*/store.js'

export default () => {

  const modules = {}
  Object.keys(stores).forEach(k => { modules[k] = stores[k] })
  return {
    namespaced: true,
    modules,
  }
}
